import { Box, Typography } from "@mui/material"

type SummaryRowProps = {
  label: string
  value: string | number
}

export const SummaryGrid = ({ children }: React.PropsWithChildren) => (
  <Box
    component="dl"
    sx={{
      display: "grid",
      gridTemplateColumns: "auto 1fr",
      rowGap: 0.5,
      columnGap: 2,
      m: 0,
    }}
  >
    {children}
  </Box>
)

export const SummaryRow = ({ label, value }: SummaryRowProps) => (
  <>
    <Typography component="dt" variant="body2" fontWeight="bold">
      {label}
    </Typography>
    <Typography component="dd" variant="body2" fontWeight="bold" sx={{ m: 0 }}>
      {value}
    </Typography>
  </>
)
